<section style="height: 100%; display: flex; flex-direction: column">
  <section
    class="mb-2"
    style="
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 0.5rem;
    "
  >
    <h4 data-cy="home-header" style="margin: 0; font-size: 120%">
      {{ 'event.header' | translate }} {{ eventDate | appDate: 'shortDate' }}
    </h4>
    <div>
      <button
        pButton
        type="button"
        icon="pi pi-angle-left"
        class="p-button-outlined mr-2"
        (click)="setDate('prev')"
      ></button>
      <button
        pButton
        type="button"
        class="p-button-default p-button-outlined mr-2"
        (click)="setDate('today')"
      >
        {{ 'event.btn-today' | translate }}
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-angle-right"
        class="p-button-outlined"
        (click)="setDate('next')"
      ></button>
    </div>
  </section>

  <p-splitter
    layout="vertical"
    [panelSizes]="outerPanelSizes"
    [minSizes]="[0, 0]"
    [style]="{ flex: '1 1 auto', minHeight: '0' }"
    (onResizeEnd)="onOuterSplitterResizeEnd($event)"
  >
    <ng-template pTemplate>
      <p-splitter
        layout="vertical"
        [panelSizes]="topPanelSizes"
        [minSizes]="[0, 0]"
        [style]="{ height: '100%' }"
        (onResizeEnd)="onTopSplitterResizeEnd($event)"
      >
        <ng-template pTemplate>
          @if (appointments) {
            <section style="overflow: auto; width: 100%; height: 100%">
              <app-event-list
                [events]="appointments"
                [options]="appointmentListOptions"
                (selectEvent)="onEventSelect($event)"
              ></app-event-list>
            </section>
          }
        </ng-template>

        <ng-template pTemplate>
          @if (todos && todos.length > 0) {
            <section
              style="
                overflow: auto;
                width: 100%;
                height: 100%;
                padding-top: 0.5rem;
              "
            >
              <h2 style="font-size: 120%">
                {{ 'event.todo-header' | translate }}
              </h2>
              <app-event-list
                [events]="todos"
                [options]="todoListOptions"
                (selectEvent)="onEventSelect($event)"
              ></app-event-list>
            </section>
          }
        </ng-template>
      </p-splitter>
    </ng-template>

    <ng-template pTemplate>
      <p-splitter
        layout="vertical"
        [panelSizes]="bottomPanelSizes"
        [minSizes]="[0, 0]"
        [style]="{ height: '100%' }"
        (onResizeEnd)="onBottomSplitterResizeEnd($event)"
      >
        <ng-template pTemplate>
          @if (draftHealthRecords && draftHealthRecords.length > 0) {
            <section
              data-cy="draft-visit-list"
              style="
                overflow: hidden;
                height: 100%;
                padding-top: 0.5rem;
                display: flex;
                flex-direction: column;
              "
            >
              <h2 style="flex-shrink: 0; font-size: 120%">
                {{ 'event.draft-visit-notes-header' | translate }}
              </h2>
              <div
                style="overflow-y: auto; flex: 1 1 auto; padding-right: 0.5rem"
              >
                <table
                  class="p-datatable p-datatable-sm p-datatable-striped"
                  style="width: 100%; border-collapse: collapse"
                >
                  <thead>
                    <tr>
                      <th
                        style="
                          text-align: left;
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      >
                        {{ 'event.customer' | translate }}
                      </th>
                      <th
                        style="
                          text-align: left;
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      >
                        {{ 'healthrecords.visit-date' | translate }}
                      </th>
                      <th
                        style="
                          text-align: left;
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      >
                        {{ 'healthrecords.reason-for-visit' | translate }}
                      </th>
                      <th
                        style="
                          text-align: left;
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      >
                        {{ 'healthrecords.tarkenne' | translate }}
                      </th>
                      <th
                        style="
                          text-align: left;
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      >
                        {{ 'healthrecords.main-diagnosis' | translate }}
                      </th>
                      <th
                        style="
                          text-align: left;
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      >
                        {{
                          'healthrecords.treatment-specification' | translate
                        }}
                      </th>
                      <th
                        style="
                          padding: 0.25rem 0.5rem;
                          position: sticky;
                          top: 0;
                          background: var(--surface-0, #fff);
                          z-index: 1;
                        "
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (record of draftHealthRecords; track record.id) {
                      <tr
                        class="pointer"
                        style="cursor: pointer"
                        data-cy="draft-visit-row"
                        [attr.data-record-id]="record.id"
                        (click)="navigateToCustomer(record.customer_id)"
                      >
                        <td style="padding: 0.25rem 0.5rem">
                          {{ record.customer_name }}
                        </td>
                        <td style="padding: 0.25rem 0.5rem">
                          {{ record.visit_date | appDate: 'shortDate' }}
                        </td>
                        <td style="padding: 0.25rem 0.5rem">
                          {{
                            record.description ||
                              ('healthrecords.templates.untitled' | translate)
                          }}
                        </td>
                        <td style="padding: 0.25rem 0.5rem">
                          {{ record.tarkenne }}
                        </td>
                        <td style="padding: 0.25rem 0.5rem">
                          {{ record.main_diagnosis }}
                        </td>
                        <td style="padding: 0.25rem 0.5rem">
                          @if (record.treatment_specification) {
                            <span>
                              {{ record.treatment_specification }}
                              @if (record.treatment_pgt) {
                                <span>-PGT</span>
                              }
                              @if (record.treatment_specification_pgt) {
                                <span>
                                  ({{
                                    record.treatment_specification_pgt
                                  }})</span
                                >
                              }
                            </span>
                          }
                        </td>
                        <td
                          style="
                            padding: 0.25rem 0.5rem;
                            padding-right: 0.75rem;
                            text-align: right;
                          "
                        >
                          <button
                            pButton
                            type="button"
                            icon="pi pi-times"
                            class="p-button-text p-button-danger p-button-sm"
                            data-cy="draft-visit-hide"
                            (click)="removeDraftFromList(record.id, $event)"
                          ></button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </section>
          }
        </ng-template>

        <ng-template pTemplate>
          <section style="overflow-y: auto; height: 100%">
            <app-expiring></app-expiring>
          </section>
        </ng-template>
      </p-splitter>
    </ng-template>
  </p-splitter>
</section>
